export const addVector = (p, deltaVector) => !deltaVector ? p : ({
    x: p.x + deltaVector.x,
    y: p.y + deltaVector.y,
});

export const addVector1 = (p, deltaValue) => ({
    x: p.x + deltaValue,
    y: p.y + deltaValue,
});
